import React from "react";
import Brand from "./Brand";
import { company, practices, navLinks } from "../data/content";

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-about">
            <Brand inverse />
            <p>
              Data services and web &amp; application development for organizations in Thailand and
              beyond.
            </p>
          </div>

          {practices.map((p) => (
            <div key={p.id}>
              <h3 className="footer-h">{p.title}</h3>
              <ul>
                {p.services.map((s) => (
                  <li key={s.title}><a href="#services">{s.title}</a></li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h3 className="footer-h">Company</h3>
            <ul>
              {navLinks.map((l) => (
                <li key={l.href}><a href={l.href}>{l.label}</a></li>
              ))}
            </ul>
            <h3 className="footer-h mt-4">Get in touch</h3>
            <ul>
              <li><a href={`mailto:${company.email}`}>{company.email}</a></li>
              <li><a href={company.officePhone.href}>{company.officePhone.label}</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>&copy; {new Date().getFullYear()} {company.name}. All rights reserved.</span>
          <span>{company.address.join(", ")}</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
